import { useCallback } from 'react';
import { useSignoutMutation } from '@src/apollo/hooks';
import useAuth0 from './useAuth0';
import { useAuth0Token } from './useAuth0Token';

export function useSignout() {
  const { signout: auth0Signout } = useAuth0();
  const { clearAuth0Token } = useAuth0Token();

  const [signout] = useSignoutMutation({
    onCompleted: () => {
      // Limpiar el token de Auth0 del localStorage
      clearAuth0Token();

      auth0Signout({
        clientID: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
        returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL,
      });
    },
    onError: (error) => {
      // Si falla el logout del backend (ej: unauthenticated),
      // igual limpiar tokens y hacer logout de Auth0
      console.log(
        'Backend logout failed, but continuing with Auth0 logout:',
        error.message
      );
      clearAuth0Token();

      auth0Signout({
        clientID: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
        returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL,
      });
    },
  });
  const onSignout = useCallback(() => signout(), [signout]);
  return onSignout;
}

export default useSignout;
